import React, { useEffect, useState } from 'react';
import { Button, Form } from 'react-bootstrap';

import {
  CreateUpdateAttachmentDto,
  CreateUpdateAttachmentDtoEnObjectTypeEnum,
  CreateUpdateContractDto,
} from '../../../common/pokCore/autogenerated/pokApiClient';
import FormRow from '../../../app/components/FormRow';
import { useTranslation } from '../../../common/hooks/useTranslation';
import { AttachmentInput } from '../Attachments/AttachmentInput';
import { newAttachmentForObject } from '../../../common/pokCore/contexts/AttachmentContext';
import { usePokCore } from '../../../common/hooks/usePokCore';

import { ContractDetailsForm } from './ContractDetailsForm';

interface ContractGeneralFormProps {
  contract: CreateUpdateContractDto;
  attachmentId?: string;
  propertyChange: (obj: Partial<CreateUpdateContractDto>) => void;
  readOnly: boolean;
  isLoading: boolean;
  setIsLoading: (isLoading: boolean) => void;
  showAttachment: boolean;
  setShowAttachment: (showAttachment: boolean) => void;
  hasEstimateItemsWithAmounts: boolean;
  clientLanguage?: string;
}

export const ContractGeneralForm: React.FC<
  ContractGeneralFormProps
> = props => {
  const [isPdfFile, setPdfFile] = useState(
    props.contract?.attachment?.name?.toLowerCase().endsWith('.pdf') ?? false,
  );
  const pok = usePokCore();

  const { t, tk } = useTranslation('projectLng');
  const readOnly = props.readOnly || props.isLoading;

  useEffect(() => {
    setPdfFile(
      props.contract?.attachment?.name?.toLowerCase().endsWith('.pdf') ?? false,
    );
  }, [props.contract?.attachment]);

  return (
    <Form className="d-grid gap-4 mb-3">
      <FormRow controlId="attachmentViewer" label={' '}>
        {isPdfFile && (
          <Button
            onClick={() => props.setShowAttachment(!props.showAttachment)}
            variant="outline-primary"
            disabled={!isPdfFile}
          >
            {props.showAttachment
              ? t(tk.contract.hideAttachment)
              : t(tk.contract.showAttachment)}
          </Button>
        )}
      </FormRow>
      <FormRow controlId="attachment" label={t(tk.attachment.attachment)}>
        <AttachmentInput
          attachment={props.contract?.attachment}
          accept="application/pdf"
          onChange={(attachment?: CreateUpdateAttachmentDto) =>
            props.propertyChange({
              attachment,
              signaturePosition: null,
              active: true,
            })
          }
          createNewAttachment={id =>
            newAttachmentForObject(
              CreateUpdateAttachmentDtoEnObjectTypeEnum.Contract,
              id,
            )
          }
          readOnly={readOnly}
          companyId={pok.getCompanyId()}
          withoutDelete={true}
        />
      </FormRow>
      <ContractDetailsForm
        contract={props.contract}
        propertyChange={props.propertyChange}
        readOnly={readOnly}
        hasEstimateItemsWithAmounts={props.hasEstimateItemsWithAmounts}
        clientLanguage={props.clientLanguage}
      />
    </Form>
  );
};
